export default __webpack_public_path__ + "media/src/usersite/images/header/nav/signup-16ba99be2b9d06837f02fd5ff34b9e37.png";